/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { reaction } from 'mobx';
import {
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxState,
    // IBuyboxProps,
    IBuyboxCallbacks,
    // IBuyboxViewProps
} from '@msdyn365-commerce-modules/buybox';
import PriceComponent from '../../components/price-component';

import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
// import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { getRichTextHtml } from '@msdyn365-commerce/core';
import { ICittaBuyboxData } from './citta-buybox.data';
import AfterPayInfo from '../../themes/citta/views/components/afterpay_info';

import Sidebar from '../../themes/citta/views/components/sidebar';
import { getBuyboxFindInStore } from '../../themes/citta/views/components/buybox-find-in-store';

import { getBuyboxProductConfigure } from '../../themes/citta/views/components/buybox-product-configure';
// import LaybuyPriceBreakdown from '../../themes/citta/views/components/layBuyPriceBreakdown';
import { getBuyboxAddToCart, getBuyboxplacebackorderAddToCart, getBuyboxProductAddToWishlist, getBuyboxProductDescription } from '../../themes/citta/views/components/buybox-small-components';

import getAttributesForSelectedVariant, { AttributesForSelectedVariantInput } from '../../data-actions/accordion/get-attributes-for-selected-variant';



import { ICittaBuyboxProps as IBuyboxExtentionProps, ICittaBuyboxResources as IBuyboxExtentionResources } from './citta-buybox.props.autogenerated';
import { Quantity } from '../../themes/citta/utilities/quantity';

import { IBuyboxViewProps } from './citta-buybox';
import { IBuyboxProps } from '../../themes/citta/definition-extensions/buybox.ext.props.autogenerated';

import Button from 'reactstrap/lib/Button';
export interface IbuyboxState{
    buttonText: string
}
export class BuyboxView extends React.PureComponent<IBuyboxViewProps & IBuyboxProps<ICittaBuyboxData> & IBuyboxExtentionProps<ICittaBuyboxData>,IbuyboxState> {
    public state:IbuyboxState = {
        buttonText: 'SHARE'
    }
  
    public componentDidMount() {
        setTimeout(function () {
            var containerEl = document.getElementsByClassName("msc-ss-carousel-vert-slide")[0];
            var elements = document.getElementsByClassName("msc-ss-carousel-vert-item");

            if (elements) {
                for (var i = 0; i < elements.length; i++) {
                    elements[i].addEventListener('click', (e: any) => {
                        containerEl.scrollTo({ left: e.target.parentNode.closest(".msc-ss-carousel-vert-item").offsetLeft - 5, behavior: 'smooth' })
                    })

                }
            }
        }, 3000);
    }

    public render(): JSX.Element | null {
        const props = this.props;

        // @ts-ignore: Compiler not recognizing condition check for function params
        reaction(
            () => (props.data.product.result ? props.data.product.result.RecordId : null),
            () => {
                if (props.context && props.data.product.result) {
                    const actionInput = new AttributesForSelectedVariantInput(
                        props.data.product.result.RecordId,
                        // @ts-ignore
                        +props.context.actionContext.requestContext.apiSettings.channelId,
                        props.data.product.result
                    );

                    getAttributesForSelectedVariant(actionInput, props.context.actionContext).catch(error => {
                        props.telemetry.warning('Unable to update attributes for Product');
                        props.telemetry.error(error);
                    });
                }
            }
        );
        const configure= getBuyboxProductConfigure(props, props.state,props.callbacks);
        const { ModuleProps, MediaGalleryContainerProps, ProductInfoContainerProps, quantity, title, rating, callbacks, state, resources, slots, stock } = props;
        const { productPrice } = props.data;

        const ChannelCountryRegionISOCode = props.data.channelConfiguration && props.data.channelConfiguration.result && props.data.channelConfiguration.result.ChannelCountryRegionISOCode;
        const prodPrice = productPrice && productPrice.result && productPrice.result.CustomerContextualPrice || 0;
        const productID = productPrice && productPrice.result && productPrice.result.ItemId || '';
        const isEnquireNow = productID.startsWith('CUS') || productID.startsWith('FWL') || productID.startsWith('EJP');
        // const laybuyImageUrl = props.config.laybuyImageUrl ? props.config.laybuyImageUrl : 'https://files-ap-prod.cms.commerce.dynamics.com/cms/api/tstpxgfmq/binary/MB3JAm';
        const afterpayImage = props.config.afterpayImage ? props.config.afterpayImage : 'https://files-ap-prod.cms.commerce.dynamics.com/cms/api/hdrzssjspt/binary/MFsJR';
        const afterpaydesktopImg = props.config.afterpaydesktopImg ? props.config.afterpaydesktopImg : 'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/hdrzssjspt/imageFileData/MFsHS';
        const afterpaymobileImg = props.config.afterpaymobileImg ? props.config.afterpaymobileImg : 'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/hdrzssjspt/imageFileData/MFsHV';
        const price = productPrice && _getBuyboxProductPrice(props, productPrice.result);
        const hidePayLaterOptions = props.config.hidePayLaterOptions;
        const hideInStoreOptions = props.config.hideInStoreOptions;
        if (slots.giftCard) {
            return (
                <Module {...ModuleProps}>
                    {slots.giftCard}
                </Module>
            );
        }

        const productAttributes = props.data && props.data.productAttributes && props.data.productAttributes.result;
        const imageOrientationProperty = productAttributes &&
            props.data?.productAttributes?.result?.filter(p => p.Name?.toLowerCase() === 'image orientation');
        const imageOrientation = imageOrientationProperty && imageOrientationProperty[0] ? imageOrientationProperty[0].TextValue! : 'portrait';

        const adjustedPrice = productPrice.result?.AdjustedPrice || 0;
        return (
            <Module {...ModuleProps}>
                <Node {...MediaGalleryContainerProps}>
                    <div className={imageOrientation.toLowerCase()}>
                        {props.mediaGallery}
                    </div>
                </Node>
                <Node {...ProductInfoContainerProps}>
                    {title}
                    <div className="buybox-price">{price}</div>
                    {adjustedPrice < 2000 &&
                        ChannelCountryRegionISOCode && (
                            (isEnquireNow || hidePayLaterOptions) ? <div /> :
                                <Sidebar text={'view options'}>
                                    {ChannelCountryRegionISOCode && !isEnquireNow &&
                                        <AfterPayInfo
                                            title={title}
                                            price={prodPrice}
                                            afterpayImage={afterpayImage}
                                            afterpaydesktopImg={afterpaydesktopImg}
                                            afterpaymobileImg={afterpaymobileImg}
                                        />
                                    }
                                    {/* hidden the laybuy sidebar but still keep the code here */}
                                    {/* {!isEnquireNow && ChannelCountryRegionISOCode === 'NZ' &&
                            <LaybuyPriceBreakdown
                                title={title}
                                price={prodPrice}
                                imageUrl={laybuyImageUrl}
                            />
                        } */}
                                </Sidebar>)}
                    {ChannelCountryRegionISOCode && (<div>{getBuyboxProductDescription(props)}</div>)}

                    {ChannelCountryRegionISOCode && _renderTextBlock(props.slots.textBlocks)}
                    {ChannelCountryRegionISOCode && slots.productAttributeLink}
                    {ChannelCountryRegionISOCode && rating}
                    {ChannelCountryRegionISOCode && quantity && _renderQuantity(quantity, callbacks, props, state, resources)}
                    {ChannelCountryRegionISOCode && configure && _renderConfigure(configure, props, state, callbacks)}
                    {ChannelCountryRegionISOCode && configure && _renderSku(configure, props)}
                    {ChannelCountryRegionISOCode && _renderEOQ(props)}
                    {ChannelCountryRegionISOCode && _renderOriginPrice(props, productPrice)}
                    {ChannelCountryRegionISOCode && stock}
                    {hideInStoreOptions ? <div /> : (ChannelCountryRegionISOCode === 'NZ' &&_renderBuyboxFindInStore(props, state, callbacks))}
                    {ChannelCountryRegionISOCode && _renderCartAndWishlistDiv(props, state, callbacks)}
                    {ChannelCountryRegionISOCode && <div className='ms-buybox__companion-and-share-container'>
                    {slots.productAttributeCompantionProduct}
                    {this._renderSelectedURL(props)}
                    </div> }
                    {ChannelCountryRegionISOCode && _renderFreeShippingMessage(props, productAttributes)}
                    {ChannelCountryRegionISOCode === 'NZ' && slots.freightCharges}
                    {ChannelCountryRegionISOCode && slots.productEOQ}

                    {ChannelCountryRegionISOCode && slots.accordion}
                    {ChannelCountryRegionISOCode && slots.productPDFSpecification}
                    {ChannelCountryRegionISOCode && slots.lightbox}
                    {ChannelCountryRegionISOCode && slots.pageLink}
                    {ChannelCountryRegionISOCode && props.shopSimilarLook && _renderShopSimilarItem(props.shopSimilarLook)}
                </Node>
            </Module>
        );
    }


    _changeText = ()=>{
        this.setState ({buttonText:'LINK COPIED'});
        setTimeout(()=>this.setState({buttonText: 'SHARE'}), 1500)
    }
    _renderSelectedURL = (props: IBuyboxViewProps & IBuyboxExtentionProps<ICittaBuyboxData>) => {
        /*eslint-disable-line prefer-template*/
        const selectedRecordId = `${props.data.product.result?.RecordId}.p`;
        let selectedURL = '';
        if(typeof window !== "undefined"){
            let replaceID = window.document.URL.split('/').pop()||'';
            selectedURL = window.document.URL.replace(replaceID, selectedRecordId)
        }
            return (
                      <Button
                      onClick={() => {navigator.clipboard.writeText(selectedURL).then(this._changeText)}}
                      className={'ms-buybox__share-button btn-primary'}
                     >
                         {this.state.buttonText}
                     </Button>
            )
        }
}


const _renderFreeShippingMessage = (props: IBuyboxViewProps & IBuyboxExtentionProps<ICittaBuyboxData>, productAttributes: AttributeValue[] | undefined) => {
    const freightItemAttr = productAttributes && productAttributes.find(attr => attr.Name === "Freight Item");
    if ((freightItemAttr && freightItemAttr.BooleanValue) || !props.config.freeShippingMessage) {
        return undefined;
    }
    /* @ts-ignore */
    const categoryPaths = props.data.categoryPaths && props.data.categoryPaths.result && props.data.categoryPaths.result;
    if (categoryPaths && categoryPaths[2] && categoryPaths[2].Name === "Furniture") {
        return undefined;
    }
    return (
        <div className='free-shipping-message'>
            <span dangerouslySetInnerHTML={getRichTextHtml(props.config.freeShippingMessage)} />
        </div>
    );
}

const _renderOriginPrice = (props:any, productPrice:any) => {
    const defaultOrderQuantityLimitsFeatureConfig = props.context?.request?.app?.platform?.enableDefaultOrderQuantityLimits;
    const originalPrice = Math.max(productPrice && productPrice.result && productPrice.result.BasePrice || 0, productPrice && productPrice.result && productPrice.result.TradeAgreementPrice || 0,  productPrice && productPrice.result && productPrice.result.AdjustedPrice || 0);
    if(!originalPrice) {
        return undefined;
    }
    if(originalPrice && defaultOrderQuantityLimitsFeatureConfig === 'b2b'){
        return (<div className='ms-buybox__RRP'><div className="product-RRP-title">RRP:</div><div className="product-RRP">${originalPrice.toFixed(2)}</div></div>);
    }
    return undefined
}

const _renderEOQ = (props:any) => {
    const defaultOrderQuantityLimitsFeatureConfig = props.context?.request?.app?.platform?.enableDefaultOrderQuantityLimits;
    const eoq = props.data?.product?.result?.Behavior?.MultipleOfQuantity;
    if(!eoq) {
        return undefined
    } 
    if(eoq && defaultOrderQuantityLimitsFeatureConfig === 'b2b'){
        return(
            <div className="ms-buybox__EOQ"><div className="product-EOQ-title">EOQ:</div><div className="product-EOQ">{eoq}</div></div>
        )
    }
    return undefined

} 


const _getBuyboxProductPrice = (props: any, productPrice: any) => {
    const { id, typeName, context, resources } = props;
    return productPrice && (React.createElement(PriceComponent, { id: id, typeName: typeName, context: context, data: { price: productPrice }, freePriceText: resources.priceFree, originalPriceText: resources.originalPriceText, currentPriceText: resources.currentPriceText }));
}

const _renderTextBlock = (textBlocks: React.ReactNode[]): JSX.Element | undefined => {
    if (!textBlocks || textBlocks.length === 0) {
        return undefined;
    }

    return (
        <>
            {textBlocks[0]}
        </>
    );
};


const _renderCartAndWishlistDiv = (props: IBuyboxViewProps & IBuyboxProps<ICittaBuyboxData>, state: IBuyboxState, callbacks: IBuyboxCallbacks): JSX.Element | undefined => {
    if (!props.addToWishlist) {
        return undefined;
    }
    const addToCart = getBuyboxAddToCart(props, state, callbacks);
    const placebackorder = getBuyboxplacebackorderAddToCart(props, state, callbacks);
    const addToWishList = getBuyboxProductAddToWishlist(props, state, callbacks);
    const estimatedDateProperty = props.data.productAvailableQuantity
        && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties.find((property => property.Key === 'EstimatedDate'));

    const estimatedDateValue = estimatedDateProperty && estimatedDateProperty.Value && estimatedDateProperty.Value.StringValue;

    let estimatedDate = "";
    if (estimatedDateValue == undefined) {
        estimatedDate = "";
    } else {
        estimatedDate = estimatedDateValue;
    }
    const HSOConfigprop = props.data.channelConfiguration.result
        && props.data.channelConfiguration.result.ExtensionProperties
        && props.data.channelConfiguration.result!.ExtensionProperties.find((property => property.Key === 'HSOConfig'));

    let HSOConfig = HSOConfigprop && HSOConfigprop.Value && HSOConfigprop.Value.IntegerValue;
    if (HSOConfig == undefined) {
        HSOConfig = 0;
    }

    const StockThresholdprop = props.data.productAvailableQuantity
        && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties.find((property => property.Key === 'StockThreshold'));

    const StockThresholdpropval = StockThresholdprop && StockThresholdprop.Value && StockThresholdprop.Value.IntegerValue;
    let StockThreshold = 0;
    if (StockThresholdpropval != undefined) {
        StockThreshold = StockThresholdpropval;
    }

    const onhandpropval = props.data.productAvailableQuantity
        && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
        && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.AvailableQuantity
    let onhand = 0;
    if (onhandpropval != undefined) {
        onhand = Number(onhandpropval);
    }

    // return (
    //     <div className='product-add-to-cart'>
    //         {estimatedDateValue ?
    //             <div className='product-add-to-cart-estimated-date'>Expected in Stock: <span className='estimated-date-value'>{estimatedDateValue}</span></div> : null}
    //         {addToCart && addToCart.errorBlock}
    //         {addToWishList?.errorBlock}
    //         <div className='buttons'>
    //             {addToCart && addToCart.button}
    //             {addToWishList?.button}
    //         </div>
    //     </div>
    // );

    if (HSOConfig === 0) {
        return (
            <div className='product-add-to-cart'>
                {estimatedDateValue ?
                    <div className='product-add-to-cart-estimated-date'>Expected in Stock: <span className='estimated-date-value'>{estimatedDateValue}</span></div> : null}
                {addToCart && addToCart.errorBlock}
                {addToWishList?.errorBlock}
                <div className='buttons'>
                    {addToCart && addToCart.button}
                    {addToWishList?.button}
                </div>
            </div>
        );
    } else {

        if (StockThreshold == 0) {
            return (
                <div className='product-add-to-cart'>
                    {estimatedDateValue ?
                        <div className='product-add-to-cart-estimated-date'>Expected in Stock: <span className='estimated-date-value'>{estimatedDateValue}</span></div> : null}
                    {addToCart && addToCart.errorBlock}
                    {addToWishList?.errorBlock}
                    <div className='buttons'>
                        {addToCart && addToCart.button}
                        {addToWishList?.button}
                    </div>
                </div>
            );

        } else {
            if (onhand >= StockThreshold) {
                return (
                    <div className='product-add-to-cart'>
                        {estimatedDateValue ?
                            <div className='product-add-to-cart-estimated-date'>Expected in Stock: <span className='estimated-date-value'>{estimatedDateValue}</span></div> : null}
                        {addToCart && addToCart.errorBlock}
                        {addToWishList?.errorBlock}
                        <div className='buttons'>
                            {addToCart && addToCart.button}
                            {addToWishList?.button}
                        </div>
                    </div>
                );

            } else {
                if (estimatedDate == "") {
                    return (
                        <div className='product-add-to-cart'>
                             {addToCart && addToCart.errorBlock}
                             {addToWishList?.errorBlock}
                            <div className='buttons'>
                                {/* <button type="button" title="Add to Cart" className="msc-add-to-cart  msc-btn btn-primary">Out Of Stock</button> */}
                                {addToCart && addToCart.button}
                                {addToWishList?.button}
                            </div>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='product-add-to-cart'>
                            {estimatedDateValue ?
                                <div className='product-add-to-cart-estimated-date'>Expected in Stock: <span className='estimated-date-value'>{estimatedDateValue}</span></div> : null}
                            <div className='buttons'>
                                {placebackorder && placebackorder.button}
                            </div>
                        </div>
                    );
                }
            }

        }
    }
};

const _renderBuyboxFindInStore = (props: IBuyboxViewProps & IBuyboxProps<ICittaBuyboxData>, state: IBuyboxState, callbacks: IBuyboxCallbacks): JSX.Element | null => {
    const findInStore = getBuyboxFindInStore(props, state, callbacks);
    const { productPrice } = props.data;
    const uomSet = productPrice && productPrice.result && productPrice.result.UnitOfMeasure || '';
    let AvailabilitypProductTitleisSet = false;
    if (uomSet == 'SET4' || uomSet == 'SET6') {
        AvailabilitypProductTitleisSet = true;
    }
    return (
        findInStore ? (
            <Node {...findInStore.ContainerProps}>
                {findInStore.storeSelector}
                {findInStore.heading}
                {findInStore.description}
                {findInStore.errors}
                {AvailabilitypProductTitleisSet ? <p>Availability: Please contact your local store for product availability.</p> : findInStore.button}
                {findInStore.modal}
            </Node>) : null
    );
};




const _renderConfigure = (configure: IBuyboxProductConfigureViewProps, props: IBuyboxViewProps & IBuyboxExtentionProps<ICittaBuyboxData>, state: IBuyboxState, callbacks: IBuyboxCallbacks): JSX.Element | null => {
    const { ContainerProps } = configure;
    const dropdowns = getBuyboxProductConfigure(props, state, callbacks);
    if (dropdowns) {
        return (
            <Node {...ContainerProps}>
                {dropdowns.dropdowns.map(_renderConfigureDropdown)}
            </Node>
        );
    } else {
        return null;
    }
};



const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};



const _renderQuantity = (quantityComponent: IBuyboxProductQuantityViewProps, callbacks: IBuyboxCallbacks, props: IBuyboxProps<ICittaBuyboxData>, state: IBuyboxState, extentionResources: IBuyboxExtentionResources): JSX.Element | null => {
    const { ContainerProps, LabelContainerProps, heading, errors } = quantityComponent;

    const {
        resources,
        context: {
            app: {
                config: {
                    maxQuantityForCartLineItem
                }
            }
        }
    } = props;

    const
        {
            quantity,
        } = state;

    const isProductAvailable: boolean = props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0] &&
        props.data.productAvailableQuantity.result[0].IsProductAvailable || false;
       
    const HSOConfigprop = props.data.channelConfiguration.result
        && props.data.channelConfiguration.result.ExtensionProperties
        && props.data.channelConfiguration.result!.ExtensionProperties.find((property => property.Key === 'HSOConfig'));

    let HSOConfig = HSOConfigprop && HSOConfigprop.Value && HSOConfigprop.Value.IntegerValue;
    if (HSOConfig == undefined) {
        HSOConfig = 0;
    }

    if (isProductAvailable) {
        const maxQuantity = props.data.productAvailableQuantity.result &&
            props.data.productAvailableQuantity.result[0] &&
            props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.AvailableQuantity || maxQuantityForCartLineItem;

        const onChange = (newValue: number) => {
            if (callbacks.updateQuantity) {
                callbacks.updateQuantity(newValue);
            }
        };
        const isB2B = props.context?.request?.app?.platform?.enableDefaultOrderQuantityLimits === 'b2b';
        const eoqQuantity = isB2B ? props.data?.product?.result?.Behavior?.MultipleOfQuantity : 1;

        return (
            <Node {...ContainerProps}>
                <Node {...LabelContainerProps}>
                    {heading}
                    {errors}
                </Node>

                <Quantity
                    id='ms-buybox__product-quantity-input'
                    max={maxQuantity || 10}
                    currentCount={quantity}
                    min={eoqQuantity}
                    onChange={onChange}
                    inputQuantityAriaLabel={resources.inputQuantityAriaLabel}
                    decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}
                    incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
                />
            </Node>
        );
    }
    else if (HSOConfig == 1) {
        const estimatedDateProperty = props.data.productAvailableQuantity
            && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
            && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties
            && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties.find((property => property.Key === 'EstimatedDate'));
        const estimatedDateValue = estimatedDateProperty && estimatedDateProperty.Value && estimatedDateProperty.Value.StringValue;
        let estimatedDate = "";
        if (estimatedDateValue == undefined) {
            estimatedDate = "";
        } else {
            estimatedDate = estimatedDateValue;
        }
        const StockThresholdprop = props.data.productAvailableQuantity
            && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
            && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties
            && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.ExtensionProperties.find((property => property.Key === 'StockThreshold'));
        const StockThresholdpropval = StockThresholdprop && StockThresholdprop.Value && StockThresholdprop.Value.IntegerValue;
        let StockThreshold = 0;
        if (StockThresholdpropval != undefined) {
            StockThreshold = StockThresholdpropval;
        }
        const onhandpropval = props.data.productAvailableQuantity
            && props.data.productAvailableQuantity.result && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity
            && props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.AvailableQuantity
        let onhand = 0;
        if (onhandpropval != undefined) {
            onhand = Number(onhandpropval);
        }
        if (StockThreshold != 0 && onhand < StockThreshold && estimatedDate != "") {
            const maxQuantity = props.data.productAvailableQuantity.result &&
                props.data.productAvailableQuantity.result[0] &&
                props.data.productAvailableQuantity.result[0].ProductAvailableQuantity.AvailableQuantity || maxQuantityForCartLineItem;
            const onChange = (newValue: number) => {
                if (callbacks.updateQuantity) {
                    callbacks.updateQuantity(newValue);
                }
            };
        const isB2B = props.context?.request?.app?.platform?.enableDefaultOrderQuantityLimits === 'b2b';
        const eoqQuantity = isB2B ? props.data?.product?.result?.Behavior?.MultipleOfQuantity : 1;
            return (
                <Node {...ContainerProps}>
                    <Node {...LabelContainerProps}>
                        {heading}
                        {errors}
                    </Node>
                    <Quantity
                        id='ms-buybox__product-quantity-input'
                        max={maxQuantity || 10}
                        currentCount={quantity}
                        min={eoqQuantity}
                        onChange={onChange}
                        inputQuantityAriaLabel={resources.inputQuantityAriaLabel}
                        decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}
                        incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
                    />
                </Node>
            );
        }
    }
    return <Node {...ContainerProps} />;
};

const _renderSku = (configure: IBuyboxProductConfigureViewProps, props: IBuyboxViewProps & IBuyboxExtentionProps<ICittaBuyboxData>): JSX.Element | null => {
    const { ContainerProps } = configure;
    const { slots } = props;
    if (slots) {
        return (
            <Node {...ContainerProps}>
                {slots.productSKU}
            </Node>
        );
    } else {
        return null;
    }
}



const _renderShopSimilarItem = (shopSimilarItem: any) => {
    const { ContainerProps, errors, input } = shopSimilarItem;
    return (React.createElement(Node, Object.assign({}, ContainerProps),
        errors,
        input));
};

export default BuyboxView;
